import { FeatureFlags } from '../FeatureFlags';
import { Module } from '../Module';

interface FeatureFlagAttrs extends ng.IAttributes {
  tbIfFeatureFlag: string;
}

/*
  Usage:
    <ELEMENT tb-if-feature-flag="exampleFlag"> I will survive if the exampleFlag flag is true </ELEMENT>
    <ELEMENT tb-if-feature-flag="!exampleFlag"> I will survive if the exampleFlag flag is false .</ELEMENT>
    Can accept multiple feature flag conditions with separator ','
    e.g. tb-if-feature-flag="featureFlag1,!featureFlag2"

    This directive is applied at the priority immediately after ng-if; if an ng-if attribute exists
    on an element alongside tb-if-feature-flag, ng-if will take precedence; but this directive's
    high priority will prevent other custom directives on the element from being applied. However,
    those other directives do get applied after the element is transcluded back into the DOM.
*/
Module.instance().directive('tbIfFeatureFlag', <any[]>[
  () => {
    return {
      transclude: 'element',
      restrict: 'A',
      priority: 599, // one lower than ng-if
      terminal: true,
      link: function(scope: ng.IScope, element: JQuery, attrs: FeatureFlagAttrs,
                     ctrl: any, $transclude: ng.ITranscludeFunction) {
        const attrValue: string = attrs.tbIfFeatureFlag;
        const featureFlags: ReadonlyArray<string> = attrValue.split(',');

        const showElement: boolean = featureFlags.every(flag => {
          const negated: boolean = flag.charAt(0) === '!';
          const flagEnabled: boolean = (<any>FeatureFlags)[flag.replace('!', '')] || false;
          return flagEnabled !== negated;
        });
        const comment = '<!-- end tbIfFeatureFlag: ' + attrValue + ' -->';

        if (showElement) {
          $transclude(scope, (clonedElement: JQuery) => {
            element.after(clonedElement, comment);
          });
        } else {
          element.after(comment);
        }

      }
    };
  }
]);
